import React, {useState, useEffect} from 'react';
import {
    Grid,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Button,
    CircularProgress,
    Box,
    FormControlLabel,
    Checkbox,
} from '@mui/material';
import 'react-date-range/dist/styles.css';
import useApi from '../../../hooks/useApi';
import StatisticsCheckbox from '../../../components/date/StatisticsCheckbox';
import SelectMulti from '../../../components/select/SelectMulti';
import 'react-date-range/dist/theme/default.css';
import KeyboardDoubleArrowDownOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowDownOutlined';
import {
    fetchRemovedBundlesFields,
    getUniqueListTypes,
    getUniqueCompanies,
} from '../../../API/AdtimizerReport';
import BackupTableOutlinedIcon from '@mui/icons-material/BackupTableOutlined';
import DateRangeSelector from '../../../components/date/DateRangeSelector';

function RemovedBundlesLogOptions({onSubmit}) {
    const {data: statistics, loading: loadingStats} = useApi(fetchRemovedBundlesFields);
    const [loading, setLoading] = useState(false);

    const [showTypes, setShowTypes] = useState(false);
    const [showCompanies, setShowCompanies] = useState(false);

    const {data: uniqTypes, loading: loadingTypes} = useApi(getUniqueListTypes);
    const {data: uniqCompanies, loading: loadingCompanies} = useApi(getUniqueCompanies);

    const [selectedTypesFilter, setSelectedTypesFilter] = useState([]);
    const [selectedCompaniesFilter, setSelectedCompaniesFilter] = useState([]);

    const today = new Date();
    today.setDate(today.getDate() + 1);
    today.setHours(0, 0, 0, 0);

    const twoWeeksAgo = new Date();
    twoWeeksAgo.setDate(twoWeeksAgo.getDate() - 6);
    twoWeeksAgo.setHours(0, 0, 0, 0);

    const [options, setOptions] = useState({
        start_date: twoWeeksAgo,
        end_date: today,
        stats: [],
        types: [],
        companies: [],
    });

    const handleSubmit = async () => {
        onSubmit(options);
    };

    const handleCheckboxChangeStat = (event) => {
        const {name, checked} = event.target;
        let stats = [...options.stats];

        if (checked) {
            stats.push(name);
        } else {
            stats = stats.filter((stat) => stat !== name);
        }

        setOptions({...options, stats});
    };

    const [selectedRange, setSelectedRange] = useState({
        startDate: new Date(options.start_date),
        endDate: new Date(options.start_date),
        key: 'selection',
    });

    const handleDateChange = (event) => {
        const endDate = new Date(event.endDate);
        endDate.setHours(12, 12, 12, 12);
        const endDateISOString = endDate.toISOString().split('T')[0];

        const startDate = new Date(event.startDate);
        startDate.setHours(12, 12, 12, 12);
        const startDateISOString = startDate.toISOString().split('T')[0];

        setSelectedRange((prevSelectedRange) => ({
            ...prevSelectedRange,
            startDate: new Date(startDateISOString),
            endDate: new Date(endDateISOString),
            key: 'selection',
        }));

        if (endDate && startDate) {
            setOptions((prevOptions) => ({
                ...prevOptions,
                start_date: startDateISOString,
                end_date: endDateISOString,
            }));
        }
    };

    useEffect(() => {
        setOptions((prevOptions) => ({
            ...prevOptions,
            types: selectedTypesFilter,
        }));
    }, [selectedTypesFilter]);

    useEffect(() => {
        setOptions((prevOptions) => ({
            ...prevOptions,
            companies: selectedCompaniesFilter,
        }));
    }, [selectedCompaniesFilter]);

    return (
        <Grid container spacing={2} sx={{width: "100%", marginLeft: '0px',}}>
            <Accordion sx={{width: "100%"}}>
                <AccordionSummary
                    expandIcon={<KeyboardDoubleArrowDownOutlinedIcon/>}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    sx={{backgroundColor: '#f0f3f5', width: "100%"}}
                >
                    Options
                </AccordionSummary>
                <AccordionDetails sx={{width: "100%"}}>
                    <Grid item xs={12} md={12} sx={{width: "100%"}}>
                        <form>
                            <Grid item xs={12} md={12} sx={{width: "100%", margin: '0px 0 25px auto'}}>
                                <Grid item xs={12} md={12}>
                                    {Object.keys(statistics).length != 0 ? (<strong>Data</strong>) : ''}
                                </Grid>
                                {statistics?.map((statistic) => (
                                    <StatisticsCheckbox
                                        key={statistic.key}
                                        statistic={statistic}
                                        checked={options.stats.includes(statistic.key)}
                                        onChange={handleCheckboxChangeStat}
                                    />
                                ))}
                            </Grid>

                            <Grid item xs={12} md={12} sx={{width: "100%", margin: '25px 0 25px auto'}}>
                                <Grid item xs={12} md={12}>
                                    <strong>Filters</strong>
                                </Grid>

                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={12}>
                                        {Object.keys(uniqTypes).length != 0 ? (
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={showTypes}
                                                        onChange={() => setShowTypes(!showTypes)}
                                                        name="Types"
                                                    />
                                                }
                                                label="Types"
                                            />) : ''}

                                        {Object.keys(uniqCompanies).length != 0 ? (
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={showCompanies}
                                                        onChange={() => setShowCompanies(!showCompanies)}
                                                        name="Companies"
                                                    />
                                                }
                                                label="Companies"
                                            />) : ''}
                                    </Grid>

                                    <Grid item xs={6}>
                                        {showTypes && (
                                            <SelectMulti
                                                label="Types"
                                                items={uniqTypes}
                                                selectedItems={selectedTypesFilter}
                                                onChange={(event) => setSelectedTypesFilter(event.target.value)}
                                                itemLabel="value"
                                                itemKey="value"
                                                itemValue="value"
                                            />
                                        )}
                                    </Grid>

                                    <Grid item xs={6}>
                                        {showCompanies && (
                                            <SelectMulti
                                                label="Companies"
                                                items={uniqCompanies}
                                                selectedItems={selectedCompaniesFilter}
                                                onChange={(event) => setSelectedCompaniesFilter(event.target.value)}
                                                itemLabel="value"
                                                itemKey="value"
                                                itemValue="value"
                                            />
                                        )}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </form>
                    </Grid>
                </AccordionDetails>
            </Accordion>
            <Grid item xs={6} md={6}>
                <Button
                    size={"large"}
                    startIcon={<BackupTableOutlinedIcon fontSize="small"/>}
                    onClick={handleSubmit}
                    type="submit"
                    variant="contained"
                    color="primary"
                    sx={{marginLeft: '-15px', marginBottom: '15px'}}
                >
                    Generate Report
                </Button>
            </Grid>
            {loading &&
                <Grid item xs={12} md={12}>
                    <Box justifyContent="center" textAlign={"center"} alignItems="center">
                        <CircularProgress size={200}/>
                    </Box>
                </Grid>}

            <Grid item xs={6} md={6}>
                <DateRangeSelector
                    initialRange={{startDate: twoWeeksAgo, endDate: today, key: 'selection'}}
                    onRangeChange={handleDateChange}
                />
            </Grid>
        </Grid>
    );
}

export default RemovedBundlesLogOptions;
